export default __webpack_public_path__ + "static/media/correct14.685373ff.mp3";